import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const DropdownMenuWrapper = styled.div`
  position: relative;
`;

export const DropdownMenuSelect = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  ${({ disabled, theme }) => disabled && `background-color: ${theme.colors.grey001}`};
`;

export const DropdownMenuText = styled(typography.P2RegularTypography)`
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const DropdownMenuIcon = styled.div`
  display: flex;
  align-items: center;

  &: before {
    content: '\\e901';
    font-family: 'Icomoon';
    font-size: 6px;
    margin-top: 3px;
  }
`;

export const DropdownMenuEnvelop = styled.div`
  position: absolute;
  top: 46px;
  width: 100%;
  height: 230px;
  padding: 4px 0;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 1;
  overflow: scroll;
`;

export const DropdownMenuEnvelopItem = styled(typography.P2RegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;
